export class ReassignOwner{
    ID:number;
    FromUserID:string="";
    ToUserID:string="";
    AssignedByID:string;
    AssignedDate:string;

}